/**
 * A clínica ativa, para o cabeçalho de cada pedido ao servidor.
 *
 * Módulo à parte, e não dentro de `sessao.ts`, porque o cliente do Supabase
 * lê isto a cada pedido e a sessão já importa o cliente: os dois importando um
 * ao outro formariam um ciclo.
 *
 * O banco usa o cabeçalho para ESTREITAR o vínculo (`0064`): quem é membro de
 * duas clínicas vê só a escolhida. Cabeçalho nunca amplia acesso — por isso a
 * preferência pode morar no navegador, como o tema: ela escolhe entre o que a
 * pessoa já alcança, e não autoriza nada.
 */

export const CABECALHO_DA_CLINICA = 'x-vecchia-clinica';

const CHAVE = 'vec.clinica';

let ativa: string | null = null;

export function clinicaAtiva(): string | null {
    return ativa;
}

export function definirClinicaAtiva(id: string | null): void {
    ativa = id;
}

/** A última clínica escolhida por esta pessoa neste navegador. */
export function clinicaPreferida(): string | null {
    try {
        return localStorage.getItem(CHAVE);
    } catch {
        /* Sem armazenamento: vale a escolha padrão. */
        return null;
    }
}

export function lembrarClinica(id: string): void {
    try {
        localStorage.setItem(CHAVE, id);
    } catch {
        /* A escolha vale só até recarregar. */
    }
}

/**
 * Em que clínica a sessão nasce.
 *
 * A preferida, se ainda for do vínculo; senão a primeira por NOME. Antes era a
 * primeira linha que o banco devolvesse — ordem que ninguém garante, e a pessoa
 * caía numa clínica diferente a cada entrada.
 */
export function escolherVinculo<T extends { clinicaId: string; clinica: string }>(vinculos: T[], preferida: string | null): T | undefined {
    const ordenados = [...vinculos].sort((a, b) => a.clinica.localeCompare(b.clinica, 'pt-BR') || a.clinicaId.localeCompare(b.clinicaId));
    return ordenados.find((v) => v.clinicaId === preferida) ?? ordenados[0];
}

/** Os cabeçalhos do pedido, com a clínica ativa quando houver. */
export function comClinicaAtiva(cabecalhos?: HeadersInit): Headers {
    const h = new Headers(cabecalhos);
    if (ativa) h.set(CABECALHO_DA_CLINICA, ativa);
    return h;
}
